"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created on Wed Nov 13 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * SegmentationModelConverter.
 *
 * @author ZSr
 */


var SegmentationModelConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SegmentationModelConverter, _DataObjectConverter_);

  function SegmentationModelConverter() {
    _classCallCheck(this, SegmentationModelConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SegmentationModelConverter).apply(this, arguments));
  }

  return SegmentationModelConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SegmentationModelConverter = SegmentationModelConverter;